import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import type { PrimeNGConfigType } from 'primeng/config';

const bluePrimary = {
  50: '{blue.50}',
  100: '{blue.100}',
  200: '{blue.200}',
  300: '{blue.300}',
  400: '{blue.400}',
  500: '{blue.500}',
  600: '{blue.600}',
  700: '{blue.700}',
  800: '{blue.800}',
  900: '{blue.900}',
  950: '{blue.950}',
};

export const ConfigurationThemePreset = definePreset(Aura, {
  semantic: {
    primary: bluePrimary,
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.400}',
      offset: '2px',
      shadow: '0 0 0 0.25rem color-mix(in srgb, {primary.500}, transparent 84%)',
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '0.625rem',
      },
    },
    card: {
      root: {
        borderRadius: '0.875rem',
      },
    },
    datatable: {
      header: {
        background: '{content.background}',
        borderColor: '{datatable.border.color}',
        color: '{content.color}',
        padding: '0.75rem 1rem',
      },
      headerCell: {
        background: '{content.background}',
        borderColor: '{datatable.border.color}',
        color: '{content.color}',
        padding: '0.75rem 1rem',
      },
      bodyCell: {
        borderColor: '{datatable.border.color}',
        padding: '0.75rem 1rem',
      },
    },
  },
});

export const ConfigurationTheme = ({
  darkModeSelector = '.app-dark',
}: {
  darkModeSelector?: string | null;
} = {}): PrimeNGConfigType => ({
  ripple: true,
  theme: {
    preset: ConfigurationThemePreset,
    options: { darkModeSelector },
  },
});
